import { faPhoneFlip, faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Chip, Typography } from '@material-ui/core';
import { FunctionComponent } from 'react';
import { useCommonStyles } from 'components/UI/CommonStyles';
import { useClientInfoStyles } from 'components/Payments/SingleSale/ClientInfo/ClientInfo.styles';
import clsx from 'clsx';
import Client from '@spike/client-model';

interface ClientInfoProps {
    data: Client;
}

export const ClientInfo: FunctionComponent<ClientInfoProps> = props => {
    const classes = useClientInfoStyles();
    const commonClasses = useCommonStyles();

    return (
        <>
            <Box className={clsx(classes.container, commonClasses.flexColumn)}>
                <Box>
                    <Typography className={clsx(classes.typo, commonClasses.typo16_600)}>
                        {`${props.data.firstName} ${props.data.lastName}`}
                    </Typography>
                </Box>
                <Box className={clsx(classes.info, commonClasses.flexRow)}>
                    <FontAwesomeIcon
                        icon={faPhoneFlip}
                        className={clsx(classes.icon)}
                    />
                    <Typography className={clsx(classes.typo, commonClasses.typo15_400)}>{props.data.phone}</Typography>
                </Box>
                <Box className={clsx(classes.info, commonClasses.flexRow)}>
                    <FontAwesomeIcon
                        icon={faEnvelope}
                        className={clsx(classes.icon)}
                    />
                    <Typography className={clsx(classes.typo, commonClasses.typo15_400)}>{props.data.email}</Typography>
                </Box>
                <Box className={classes.tagContent}>
                    {props.data.tags.positive.map(tag => (
                        <Chip
                            key={tag.id}
                            label={tag.name}
                            className={classes.clientTag}
                        />
                    ))}

                    {props.data.tags.negative.map(tag => (
                        <Chip
                            key={tag.id}
                            label={tag.name}
                            className={classes.clientTag}
                        />
                    ))}
                </Box>
            </Box>
        </>
    );
};

export default ClientInfo;
